import React from 'react'
import { useParams } from 'react-router-dom'

import { Panel } from 'rsuite'
import ProductReviewModerationForm from '@components/catalog/productReview/moderation/ProductReviewModerationForm'

export default function ProductReviewModerationFormPage () {
  const { brandSlug } = useParams<any>()

  return (
    <div className="ProductReviewModerationFormPage">
      <h1 className="u-heading">Модерирование отзывов</h1>
      <Panel shaded>
        <ProductReviewModerationForm brandSlug={brandSlug} />
      </Panel>
    </div>
  )
}
